import {
  IntIteratordtlvcwxsuu5a as IntIterator,
  LongIterator6nf6jdg4ti4 as LongIterator,
  CharIterator2h6gbyxoj1es2 as CharIterator,
} from '../collections/PrimitiveIterators.mjs';
import { NoSuchElementException679xzhnp5bpj as NoSuchElementException } from '../exceptions.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { add2suhfggl4zvkk as add } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Char__toInt_impl_vasixd1agw9q2fuvclj as Char__toInt_impl_vasixd,
  Char__compareTo_impl_ypi4mbdrkik40uwhqc as Char__compareTo_impl_ypi4mb,
} from '../Char.mjs';
import { numberToChar93r9buh19yek as numberToChar } from '../js/numberConversion.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var IntProgressionIteratorClass;
function IntProgressionIterator() {
  if (IntProgressionIteratorClass === VOID) {
    class $ extends IntIterator() {
      constructor(first, last, step) {
        super();
        this.gs_1 = step;
        this.hs_1 = last;
        this.is_1 = this.gs_1 > 0 ? first <= last : first >= last;
        this.js_1 = this.is_1 ? first : this.hs_1;
      }
      n1() {
        return this.is_1;
      }
      ul() {
        var value = this.js_1;
        if (value === this.hs_1) {
          if (!this.is_1)
            throw NoSuchElementException().y1();
          this.is_1 = false;
        } else {
          this.js_1 = this.js_1 + this.gs_1 | 0;
        }
        return value;
      }
    }
    initMetadataForClass($, 'IntProgressionIterator');
    IntProgressionIteratorClass = $;
  }
  return IntProgressionIteratorClass;
}
var LongProgressionIteratorClass;
function LongProgressionIterator() {
  if (LongProgressionIteratorClass === VOID) {
    class $ extends LongIterator() {
      constructor(first, last, step) {
        super();
        this.ks_1 = step;
        this.ls_1 = last;
        this.ms_1 = this.ks_1 > 0n ? first <= last : first >= last;
        this.ns_1 = this.ms_1 ? first : this.ls_1;
      }
      n1() {
        return this.ms_1;
      }
      vl() {
        var value = this.ns_1;
        if (value === this.ls_1) {
          if (!this.ms_1)
            throw NoSuchElementException().y1();
          this.ms_1 = false;
        } else {
          this.ns_1 = add(this.ns_1, this.ks_1);
        }
        return value;
      }
    }
    initMetadataForClass($, 'LongProgressionIterator');
    LongProgressionIteratorClass = $;
  }
  return LongProgressionIteratorClass;
}
var CharProgressionIteratorClass;
function CharProgressionIterator() {
  if (CharProgressionIteratorClass === VOID) {
    class $ extends CharIterator() {
      constructor(first, last, step) {
        super();
        this.os_1 = step;
        var tmp = this;
        // Inline function 'kotlin.code' call
        tmp.ps_1 = Char__toInt_impl_vasixd(last);
        this.qs_1 = this.os_1 > 0 ? Char__compareTo_impl_ypi4mb(first, last) <= 0 : Char__compareTo_impl_ypi4mb(first, last) >= 0;
        var tmp_0 = this;
        var tmp_1;
        if (this.qs_1) {
          // Inline function 'kotlin.code' call
          tmp_1 = Char__toInt_impl_vasixd(first);
        } else {
          tmp_1 = this.ps_1;
        }
        tmp_0.rs_1 = tmp_1;
      }
      n1() {
        return this.qs_1;
      }
      xl() {
        var value = this.rs_1;
        if (value === this.ps_1) {
          if (!this.qs_1)
            throw NoSuchElementException().y1();
          this.qs_1 = false;
        } else {
          this.rs_1 = this.rs_1 + this.os_1 | 0;
        }
        return numberToChar(value);
      }
    }
    initMetadataForClass($, 'CharProgressionIterator');
    CharProgressionIteratorClass = $;
  }
  return CharProgressionIteratorClass;
}
//region block: exports
export {
  CharProgressionIterator as CharProgressionIterator34nq4ujuknl08,
  IntProgressionIterator as IntProgressionIterator2ovd1ctrmu51n,
  LongProgressionIterator as LongProgressionIterator2e3slqmdh4zt7,
};
//endregion

//# sourceMappingURL=ProgressionIterators.mjs.map
